<template>
  <b-modal id="modal-checkin-options"
           modal-class="modal-mobile-fullscreen modal-checkin-options"
           centered
           @shown="show"
           @hidden="reset"
           size="md" no-close-on-backdrop
           v-if="stepData"
  >
    <template v-slot:modal-header>
      <h5 class="modal-title">{{ stepData.question || '' }}</h5>
    </template>
    <div class="text-center d-flex align-items-center justify-content-center h-100" v-if="stepData.options">
      <ul class="list-unstyled options w-100">
        <li v-for="option in stepData.options" :key="option.id" class="option">
          <a href="#" @click.prevent="setOption(option)"
             :class="['link-option', {'on': option.id === selectedOptionId}]">
            <div class="content-option">
              <div class="image-option" v-if="option.image">
                <img :src="option.image" :alt="option.name">
              </div>
              <div class="name-option" v-if="option.name">{{ option.name }}</div>
              <div class="description-option" v-if="option.description">{{ option.description }}</div>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <template v-slot:modal-footer>
      <b-button variant="primary" block @click="save()"
                :disabled="!selectedOptionId">
        {{ $t('modal_checkin_options.action_confirm') }}
      </b-button>
    </template>
  </b-modal>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import {NextStepRequired} from "@/domain/autologin/exceptions";

export default {
  data() {
    return {
      selectedOptionId: null,
    }
  },

  computed: {
    ...mapGetters('checkin', [
      'stepData',
      'picacode'
    ]),
  },
  methods: {
    ...mapActions('checkin', [
      'completeCheckin',
      'openStepModal',
    ]),
    show() {
      this.selectedOptionId = null
    },
    reset() {
      this.selectedOptionId = null
    },
    setOption(option) {
      this.selectedOptionId = (option.id === this.selectedOptionId) ? null : option.id
    },
    async save() {
      try {
        await this.completeCheckin({option: this.selectedOptionId})
        this.$bvModal.hide('modal-checkin-options')
        await this.$router.push({name: 'checkins-detail', params: {picacode: this.picacode, msDelay: 2800}})
      } catch (e) {
        if (e instanceof NextStepRequired) {
          await this.openStepModal()
        } else {
          throw e
        }
      }
    }
  }
}
</script>
